import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// Si une requête API renvoie 401 (sauf /auth/me lors du check initial), redirige vers /login
let onUnauthorized = null;
export const setOnUnauthorized = (fn) => { onUnauthorized = fn; };

// Phase 101ea.12 (Feb 2026) — Auto-refresh JWT pour PWA tournée
// Contexte : le livreur/bof installe AM sur téléphone en PWA. Sans auto-refresh,
// le token access 12h expire et redemande login → mauvaise UX terrain.
// On intercepte les 401, on tente `POST /auth/refresh` (refresh_token 30j),
// et on rejoue la requête originale une fois. Miroir du shop_auth pattern.
let _refreshing = null;   // promise partagée pour éviter multiples refresh parallèles

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const status = error?.response?.status;
    const original = error?.config || {};
    const url = original.url || "";

    // Ne pas tenter de refresh sur les routes auth (login, me, refresh) ni si déjà retenté
    const isAuthPath =
      url.includes("/auth/refresh") ||
      url.includes("/auth/login") ||
      url.includes("/auth/logout");

    if (status === 401 && !isAuthPath && !original._retriedRefresh) {
      original._retriedRefresh = true;
      try {
        if (!_refreshing) {
          _refreshing = api.post("/auth/refresh").finally(() => {
            _refreshing = null;
          });
        }
        await _refreshing;
        // Refresh OK — rejoue la requête originale une seule fois
        return api(original);
      } catch (_e) {
        // Refresh KO → session vraiment expirée
        if (onUnauthorized && !url.includes("/auth/me")) onUnauthorized();
        return Promise.reject(error);
      }
    }

    if (status === 401 && !url.includes("/auth/me") && !url.includes("/auth/login")) {
      if (onUnauthorized) onUnauthorized();
    }
    return Promise.reject(error);
  }
);
